export default __webpack_public_path__ + "static/media/FS-HOME-SERVICIOS-DESARROLLO-IMAGEN.3e64e8c7.png";